import React, { useMemo } from 'react';
import { theme } from '@garnish/constants';
import { Image as ExpoImage } from 'expo-image';

import { useImageSourceProps } from './hooks';
import { type ImageProps } from './Image.types';
import { getImageForCurrentScreen, withHttpsProtocol } from './Image.utils';

// ─────────────────────────────────────────────────────────────────────────────

export const Image = (props: ImageProps) => {
  const {
    source,
    tintColor,
    'aria-label': ariaLabel,
    staticSourceUrl,
    ...rest
  } = props;

  // ─────────────────────────────────────────────────────────────────────

  const formattedSource = useMemo(
    () => getImageForCurrentScreen(withHttpsProtocol(source)),
    [source],
  );

  const imageSourceProps = useImageSourceProps({
    source: formattedSource,
    staticSourceUrl,
  });

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ExpoImage
      tintColor={tintColor}
      transition={theme.transitions.image}
      accessibilityLabel={ariaLabel}
      {...imageSourceProps}
      {...rest}
    />
  );
};
